module.exports = __webpack_public_path__ + "img/require-icon-5.a142c0b5.png";